import Button from '@material-ui/core/Button'

import clsx from 'clsx'
import { elementsGroupToggleStyles } from 'components/ElementsTree/styles/elementsGroupToggleStyles'
import { ElementPanelSubItem } from 'models/projectElements'
import React from 'react'

export interface GroupButtonProps {
    label: string
    selectedGrouppingType?: ElementPanelSubItem
    handleSelectElementGroup?: (value: string) => void
    isSearchBarHiddenInSMMOM?: boolean
}

export const GroupButton = ({
    label,
    selectedGrouppingType,
    handleSelectElementGroup,
    isSearchBarHiddenInSMMOM,
}: GroupButtonProps) => {
    const classes = elementsGroupToggleStyles({
        isSearchBarHiddenInSMMOM,
    })

    return (
        <Button
            data-testid={`select-${label.toLowerCase()}-elementGroup`}
            onClick={() => handleSelectElementGroup?.(label.toUpperCase())}
            className={clsx(
                classes.divisionsAssemblyButton,
                selectedGrouppingType?.type === label?.toUpperCase()
                    ? classes.activeGroupping
                    : ''
            )}
        >
            {label}
        </Button>
    )
}
